export interface MasterDataImportResult {
  success?: boolean;
  created?: number;
  updated?: number;
  skipped?: number;
  successful?: number;
  failed?: number;
  exported?: number;
  errors?: string[];
  error?: string;
}

export const downloadJsonFile = (data: unknown, fileName: string): void => {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

export const readJsonFile = (file: File): Promise<unknown> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        resolve(JSON.parse(String(reader.result || '')));
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });

export const formatMasterDataImportMessage = (result: MasterDataImportResult): string => {
  if (result.error) {
    return result.error;
  }

  const created = result.created ?? 0;
  const updated = result.updated ?? 0;
  const successful = result.successful ?? 0;
  const failed = result.failed ?? 0;
  const errorCount = result.errors?.length ?? 0;

  const parts: string[] = [];
  if (created) parts.push(`${created} created`);
  if (updated) parts.push(`${updated} updated`);
  if (successful) parts.push(`${successful} imported`);
  if (failed) parts.push(`${failed} failed`);
  if (errorCount) parts.push(`${errorCount} errors`);

  if (parts.length === 0) {
    return 'Import completed';
  }
  return `Import completed: ${parts.join(', ')}`;
};

export const todayExportSuffix = (): string => new Date().toISOString().split('T')[0];
